import React from 'react';
import SkeletonEllipse from '@components/ui/Skeleton/SkeletonEllipse';
import SkeletonRow from '@components/ui/Skeleton/SkeletonRow';
import * as Styled from './SkeletonStyles';

function Skeleton() {
  return (
    <>
      <Styled.WrapperHeader>
        <SkeletonEllipse width="12px" height="12px" />
        <SkeletonRow width="105px" height="19px" />
        <Styled.AlignRight>
          <SkeletonRow width="88px" height="16px" />
        </Styled.AlignRight>
      </Styled.WrapperHeader>
      <Styled.Content>
        <SkeletonRow width="145px" height="24px" />
      </Styled.Content>
    </>
  );
}

export default Skeleton;
